import Swiper, { Lazy } from 'swiper';

let slider: Swiper | null;

const handlePrevClick = () => {
    if (slider) {
        slider.slidePrev(500);
    }
};

const handleNextClick = () => {
    if (slider) {
        slider.slideNext(500);
    }
};

const init = () => {
    const spaceBetween = window.innerWidth < 768 ? 8 : window.innerWidth < 1024 ? 24 : window.innerWidth ? 40 : 60;

    slider = new Swiper('.js-certificates-slider', {
        modules: [Lazy],
        slidesPerView: 1,
        spaceBetween,
    });

    const prevButton = document.querySelector('.js-catalog-certificates__prev');
    const nextButton = document.querySelector('.js-catalog-certificates__next');

    if (prevButton && nextButton) {
        prevButton.addEventListener('click', handlePrevClick);
        nextButton.addEventListener('click', handleNextClick);
    }

    const certificates = Array.from(document.querySelectorAll<HTMLElement>('.js-c-certificate'));

    certificates.forEach((certificate) => {
        const colorElement = certificate.querySelector('.js-c-certificate__color');

        if (colorElement) {
            certificate.style.background = colorElement.innerHTML;
        }
    });
};

const destroy = () => {
    if (slider) {
        slider.destroy();
    }

    const prevButton = document.querySelector('.js-catalog-certificates__prev');
    const nextButton = document.querySelector('.js-catalog-certificates__next');

    if (prevButton && nextButton) {
        prevButton.removeEventListener('click', handlePrevClick);
        nextButton.removeEventListener('click', handleNextClick);
    }
};

const _module = { init, destroy };

export default _module;
